module.exports = __webpack_public_path__ + "static/media/activity-finished.cb0e1000.svg";